import styled from 'styled-components'

import AppButton from 'Components/AppButton'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import {
  CLICKABLE_COLOR,
  HYPER_LINK_COLOR,
  ERROR_COLOR,
  SITE_BLACK_COLOR,
} from '@CSSVars/colors'

export const _Signup = styled.div`
  width: ${({ isSecondStep }) => (isSecondStep ? '435px' : '350px')};
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  h4 {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 24px;
  }
  input {
    border-radius: 10px;
    height: 44px;
    font-size: 14px;
  }
  
   @media screen and (min-width: ${BREAK_POINT_LG}) {
    h4 {
      font-size: 18px;
      margin-bottom: 24px;
      font-weight: 500;
    }
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    h4 {
      text-align:   ${({ loginPage }) => (loginPage ? 'left' : 'center')};
    }
  }
`

export const _FirstStep = styled.div`
  h5 {
    line-height: 22px;
    margin-top: 24px;
    margin-bottom: 4px;
    font-weight: 500;
    text-align: center;
  }
  @media screen and (max-width: 767px) {
    form {
      margin-bottom: 16px;
    }
  }
`

export const _LoginSwitch = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  display: inline-block;
  color: ${CLICKABLE_COLOR};
  cursor: pointer;
  text-decoration: underline;
  &:focus {
    color: ${HYPER_LINK_COLOR};
  }
`

export const _SubmitCta = styled(AppButton)`
  width: 100%;
  position: relative;
`

export const _SecondStep = styled.div`
  max-width: 100%;

  form {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;
  }
`

export const _Col = styled.div`
  max-width: ${({ isHalfCol }) => (isHalfCol ? '50%' : '100%')};
  flex-basis: ${({ isHalfCol }) => (isHalfCol ? '50%' : '100%')};
  padding: 0 8px;

  ${({ isPasswordCol }) =>
    (isPasswordCol
      ? `
        position: relative;
        margin-bottom: 16px;
      `
      : '')}

  ${({ isCheckboxCol }) =>
    (isCheckboxCol
      ? `
        margin-bottom: 24px;
      `
      : '')}

  ${({ isTermsConditionsCol }) =>
    (isTermsConditionsCol
      ? `
        margin-top: 16px;
        line-height: 20px;
        font-size: 12px;
        a {
          font-size: inherit;
          text-decoration: underline;
          color: ${CLICKABLE_COLOR};
        }
      `
      : '')}
`

export const _IamAgentCol = styled(_Col)`
  svg {
    .square {
      fill: ${SITE_BLACK_COLOR};
    }
  }
  ${({ iAmAgent }) =>
    iAmAgent &&
    `
    font-size: 12px;
    line-height: 16px;
    .squareCheckbox {
      border-color: ${ERROR_COLOR};
    }
    color: ${ERROR_COLOR};

    svg {
      fill: ${ERROR_COLOR} !important;
    }
    a {
      color: ${CLICKABLE_COLOR};
      text-decoration: underline;
      font-size: 12px;
    }
  `}
`

export const _AgentErrorTitle = styled.div`
  margin: 12px 0 8px 0;
  strong {
    color: ${ERROR_COLOR};
  }
`

export const _PasswordTip = styled.div`
  font-size: 12px;
  position: absolute;
  bottom: 6px;
  line-height: 10px;
`

export const _AlreadyHaveAccount = styled.div`
  height: 30px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
`

export const _SlidingModalTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: -16px 0 24px;
`
